import { ISiteDTO } from "@/Administration/Api/Dto/Sites/ISiteDTO";
import { IClinicLogo } from "@/Common/Models/Sites/IClinicLogo";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";

class SitesTabAction extends BaseAction {
    constructor() {
        super();
    }

    public loadSites(): void {
        this.Execute(ServerOperations.Server.Myle_AdministrationGetSites);
    }

    public getCostCenters(siteId: string): void {
        this.Execute(ServerOperations.Server.Myle_Administration_Site_LoadCostCenter, {
            SiteId: siteId
        });
    }

    public saveSite(dto: ISiteDTO, proceedWithSave: boolean): void {
        this.Execute(ServerOperations.Server.Myle_Administration_Site_Upsert, {
            SiteDto: dto,
            ProceedWithSave: proceedWithSave
        });
    }

    public saveLogo(logoAttachments: IClinicLogo[], siteId: string, forAllSites: boolean): void {
        const requestData = {
            LogoAttachments: logoAttachments,
            SiteId: siteId,
            ForAllSites: forAllSites
        };

        this.Execute(ServerOperations.Server.Myle_Administration_Site_UploadLogo, requestData);
    }
}

export { SitesTabAction };
